import { render } from "./BlankPageSalesOne.vue?vue&type=template&id=108ae50d&scoped=true"
import script from "./BlankPageSalesOne.vue?vue&type=script&lang=js"
export * from "./BlankPageSalesOne.vue?vue&type=script&lang=js"

import "./BlankPageSalesOne.vue?vue&type=style&index=0&id=108ae50d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108ae50d"]])

export default __exports__